export default "/_next/static/assets/images/sprite.bcf80905a392a0ac05dade688aa6c25b.svg";